import type { ReactElement } from 'react';

import type { ICardFooterProps } from './card.interface';

export const CardFooter = ({
  children,
  className
}: ICardFooterProps): ReactElement => {
  return (
    <div className={`${className ? className : 'co-p-2.5'}`}>{children}</div>
  );
};
